// extracted by mini-css-extract-plugin
export default {"header":"header_header__GyDbi","title":"header_title__GsHQO","border":"header_border__kyBJ7"};